/**
 * Formatação de tamanho de arquivo (pt-BR) usada nos blocos de backup/exportação.
 * B/KB sem casas decimais, MB/GB com 1 casa decimal.
 */
export const formatBytes = (bytes) => {
    const value = Number(bytes) || 0;

    if (value <= 0) return '0 B';
    if (value < 1024) return `${value} B`;
    if (value < 1024 * 1024) return `${Math.round(value / 1024)} KB`;
    if (value < 1024 * 1024 * 1024) return `${(value / (1024 * 1024)).toFixed(1)} MB`;

    return `${(value / (1024 * 1024 * 1024)).toFixed(1)} GB`;
};
